import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "uv-tile" }
const _hoisted_2 = { class: "uv-tile-vehicle" }
const _hoisted_3 = ["href"]
const _hoisted_4 = { class: "uv-tile-title" }
const _hoisted_5 = ["href"]
const _hoisted_6 = {
  key: 0,
  class: "uv-tile-toyotacertified"
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "uv-tile-bottom" }
const _hoisted_9 = {
  key: 0,
  class: "uv-tile-location"
}
const _hoisted_10 = { class: "uv-tile-location-marker" }
const _hoisted_11 = { class: "uv-tile-hidden" }
const _hoisted_12 = {
  key: 1,
  class: "uv-tile-list-noresults"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", null, "No vehicles were found", -1)
const _hoisted_14 = [
  _hoisted_13
]

import { computed } from 'vue'; 
	import { useStore } from 'vuex';
	import { IStoreState, IVehicle } from '@/types.d';
	import { ECtas } from '@/enums';
	import { dataDomain } from '@/config';
	import VehicleSubtitle from './VehicleSubtitle.vue';
	import VehicleDescription from './VehicleDescription.vue';
	import VehiclePrice from './VehiclePrice.vue';
	import VehicleCtas from './VehicleCtas.vue';
	import VehicleQuickLookCta from './VehicleQuickLookCta.vue';
	import VehicleFlags from './VehicleFlags.vue';
	import { MapMarker } from '@/svg';

	
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

	const store = useStore<IStoreState>();

	const isRetrievingData = computed(() => store.state.isRetrievingData);
	const hasMadeInitialUpdateVehicles = computed(() => store.state.hasMadeInitialUpdateVehicles);
	const hasFinishedInitialDataRetrieval = computed(() => hasMadeInitialUpdateVehicles.value);
	const listClass = computed((): string => `uv-tile-list ${isRetrievingData.value ? 'tiles-loading' : ''}`);
	const vehicles = computed((): Array<IVehicle> => store.state.vehicles);
	const showLocation = computed(() => store.state.showLocation);

	const getTileStyle = (vehicle: IVehicle): string => {
		let s = "background-image: ";
		if (vehicle.Photos && vehicle.Photos.length){
			s += -1 !== vehicle.Photos[0].indexOf('http') ? `url(${vehicle.Photos[0]});` : `url(${dataDomain}${vehicle.Photos[0]});`;
		}
		return s;
	};
	const getFueldTypeClass = (vehicle: IVehicle) => {
		return vehicle.FuelType && typeof vehicle.FuelType === 'string' && vehicle.FuelType.toUpperCase() === 'HYBRID' ? ' uv-hybrid' : ' uv-petrol';
	}
	const handleCertifiedClick = (vehicle: IVehicle) => {
		store.commit('setEnquiryModal', {
			isVisible: true, 
			type: ECtas.certifiedText, 
			vehicle: vehicle
		});
	}


return (_ctx: any,_cache: any) => {
  return (_unref(vehicles).length && _unref(hasFinishedInitialDataRetrieval))
    ? (_openBlock(), _createElementBlock("ul", {
        key: 0,
        id: "uv-tile-list",
        "aria-live": "polite",
        class: _normalizeClass(_unref(listClass))
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(vehicles), (v) => {
          return (_openBlock(), _createElementBlock("li", {
            key: v.StockId,
            class: "ac-col"
          }, [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("a", {
                  href: v.DetailsPageUrl
                }, [
                  _createElementVNode("div", {
                    class: "uv-tile-photo",
                    style: _normalizeStyle(getTileStyle(v))
                  }, [
                    _createVNode(VehicleFlags, { vehicle: v }, null, 8, ["vehicle"])
                  ], 4)
                ], 8, _hoisted_3),
                _createVNode(VehicleQuickLookCta, { vehicle: v }, null, 8, ["vehicle"]),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("a", {
                    href: v.DetailsPageUrl
                  }, _toDisplayString(v.ManuYear ? v.ManuYear : '') + " " + _toDisplayString(v.Make) + " " + _toDisplayString(v.Model), 9, _hoisted_5)
                ]),
                _createVNode(VehicleSubtitle, { vehicle: v }, null, 8, ["vehicle"]),
                (v.IsToyotaCertifiedBool)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createElementVNode("button", {
                        onClick: _withModifiers(($event: any) => (handleCertifiedClick(v)), ["prevent"])
                      }, "Toyota Certified", 8, _hoisted_7)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(VehicleDescription, { vehicle: v }, null, 8, ["vehicle"]),
                  _createElementVNode("div", {
                    class: _normalizeClass('uv-tile-fuelType ' + getFueldTypeClass(v))
                  }, _toDisplayString(v.FuelType), 3),
                  (_unref(showLocation))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _createElementVNode("span", _hoisted_10, [
                          _createVNode(_unref(MapMarker))
                        ]),
                        _createTextVNode(" " + _toDisplayString(v.Location), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode(VehiclePrice, {
                    vehicle: v,
                    weekly: "{vehicle.Weekly}",
                    disclaimerSymbols: "{vehicle.DisclaimerSymbols}",
                    price: "{vehicle.WasPrice}",
                    saleprice: "{vehicle.Price}"
                  }, null, 8, ["vehicle"]),
                  _createElementVNode("div", _hoisted_11, _toDisplayString(v.StockNum), 1),
                  _createVNode(VehicleCtas, { vehicle: v }, null, 8, ["vehicle"])
                ])
              ])
            ])
          ]))
        }), 128))
      ], 2))
    : (_unref(hasFinishedInitialDataRetrieval))
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_14))
      : _createCommentVNode("", true)
}
}

})